import api from './api'

// 输出模块
export default api



// WEBPACK FOOTER //
// ./src/api/index.js